export * from "./ProgressBar";
export { default as ProgressBar } from "./ProgressBar";
export * from "./ProgressBarExpensesInvoiced";
export * from "./ProgressBarExpensesReceived";
export * from "./ProgressBarOurWorkInvoiced";
export * from "./ProgressBarOurWorkSpend";

export const p = (val: number) => `${val.toFixed(1)}%`;
